import axios from 'axios';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { CommonState, error, isFetching } from '@pec/aion-ui-core/slices/common';
import { enqueueRequestErrorSnackbar } from '@pec/aion-ui-core/actions/enqueueSnackbar';
import { ExpirationDateType, IExpiringQuestion } from '../interfaces/questions';

const name = 'questions';

export const fetchExpiredQuestions = createAsyncThunk(
  `${name}/fetchExpired`,
  async (organizationId: string, { dispatch }) => {
    try {
      const { data } = await axios.get<IExpiringQuestion[]>(
        `/api/questionnaire/v1/organizations/${organizationId}/questions/expiringin`,
        {
          params: {
            expirationDateTypes: ExpirationDateType.Expired
          }
        }
      );
      return data;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export const fetchExpiringQuestions = createAsyncThunk(
  `${name}/fetchExpiring`,
  async (organizationId: string, { dispatch }) => {
    try {
      const { data } = await axios.get<IExpiringQuestion[]>(
        `/api/questionnaire/v1/organizations/${organizationId}/questions/expiringin`,
        {
          params: {
            expirationDateTypes: ExpirationDateType.Expiring
          }
        }
      );
      return data;
    } catch (error) {
      dispatch(enqueueRequestErrorSnackbar());
      throw error;
    }
  }
);

export type State = CommonState & {
  expiredQuestions: IExpiringQuestion[];
  expiringQuestions: IExpiringQuestion[];
};

const initialState: State = {
  expiredQuestions: [],
  expiringQuestions: [],
  isFetching: false,
  error: null
};

const questions = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchExpiredQuestions.pending, isFetching)
      .addCase(fetchExpiredQuestions.fulfilled, (state, action) => {
        state.expiredQuestions = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchExpiredQuestions.rejected, error)
      .addCase(fetchExpiringQuestions.pending, isFetching)
      .addCase(fetchExpiringQuestions.fulfilled, (state, action) => {
        state.expiringQuestions = action.payload;
        state.isFetching = false;
      })
      .addCase(fetchExpiringQuestions.rejected, error);
  }
});

export const { reducer: questionsReducer } = questions;
